import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth, setPersistence, browserLocalPersistence, GoogleAuthProvider } from "firebase/auth";
import { getFunctions, httpsCallable } from "firebase/functions";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyB7JnzElwKSYPsc0HWro34MRrhRtCS1g00",
  authDomain: "restaurant-management-swg.firebaseapp.com",
  projectId: "restaurant-management-swg",
  storageBucket: "restaurant-management-swg.firebasestorage.app",
  messagingSenderId: "130633993035",
  appId: "1:130633993035:web:2a53bda518c3a80e0ff6ce"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();
const functions = getFunctions(app);
const projectId = firebaseConfig.projectId;
const realtimeDb = getDatabase();

// Ensure the user session persists across refresh
setPersistence(auth, browserLocalPersistence);

//export default db;

export { db, auth, googleProvider, functions, projectId, realtimeDb, httpsCallable};